export interface SiteMapPageContent {
  sections: {
    title: string
    links: { name: string; href: string }[]
  }[]
}

const sections = [
  {
    title: 'Our Service',
    links: [
      { name: 'Create Account', href: '/book' },
      { name: 'Login', href: '/book/login' },
      { name: 'Ship', href: '/book/ship' },
      { name: 'Tracking', href: '/order-tracking' },
      { name: 'Drop Off Locator', href: 'https://www.shipsticks.com/store_locator' },
    ],
  },
  {
    title: 'Learn More',
    links: [
      { name: 'How It Works', href: '/how-it-works' },
      { name: 'Reviews', href: '/reviews' },
      { name: 'FAQ', href: '/faq' },
      { name: 'Partners', href: '/partnership-benefits' },
      { name: 'Airline Baggage Fees', href: 'https://www.shipsticks.com/airline-baggage-fees' },
    ],
  },
  {
    title: 'News',
    links: [
      { name: 'Blog', href: 'https://www.shipsticks.com/blog/' },
      { name: 'Golf Gear', href: 'https://www.shipsticks.com/blog/golf-gear/' },
      { name: 'Golf Tips', href: 'https://www.shipsticks.com/blog/tips/' },
      { name: 'Travel Tips', href: 'https://www.shipsticks.com/blog/tips/travel-tips/' },
      { name: 'Golf Destinations', href: 'https://www.shipsticks.com/blog/travel/' },
      { name: 'Industry News & Events', href: 'https://www.shipsticks.com/blog/news/t' },
    ],
  },
  {
    title: 'Help',
    links: [
      { name: 'Support Center', href: 'https://support.shipsticks.com/hc/en-us' },
      { name: 'File a claim', href: '/claims' },
      { name: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About Us', href: '/about' },
      { name: 'Careers', href: '/careers' },
    ],
  },
  {
    title: 'Our Brands',
    links: [
      { name: 'Ship Your Skis', href: 'https://www.shipsticks.com/ship-skis/' },
      { name: 'Ship Play', href: 'https://www.shipplay.com/' },
      { name: 'Ship Camps', href: 'https://www.shipcamps.com/' },
      { name: 'Ship Go', href: 'https://www.shipgo.com/' },
      { name: 'Ship Schools', href: 'https://www.shipschools.com/' },
      { name: 'Ship Luggage', href: 'https://www.luggagefree.com' },
      { name: 'Luggage Free', href: 'https://www.luggagefree.com/' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Use', href: '/terms' },
    ],
  },
]

const content: SiteMapPageContent = {
  sections,
}

export default content
